import '../style/loading.css'

export default function LoadingPage(props){
    
      return(
        <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
      )
}